import { flash } from "@xola/ui-kit";
import React from "react";
import { Route, RouteProps, useHistory } from "react-router-dom";
import { Permission } from "types";
import { useAuthorization } from "../hooks/useAuthorization";

interface ProtectedRouteProps {
    permission: Permission;
    children: any;
    exact?: RouteProps["exact"];
    path?: RouteProps["path"];
}
export const ProtectedRoute = ({ permission, children, exact, path }: ProtectedRouteProps) => {
    const history = useHistory();
    const { isGranted } = useAuthorization();
    const isGrantedPermission = isGranted(permission);

    if (!isGrantedPermission) {
        flash.danger("You are not authorized to access this page.");
        history.push("/");
        return null;
    }

    return (
        <Route exact={exact} path={path}>
            {children}
        </Route>
    );
};
